import type { TaskPayload } from "../types";

export function buildTaskPayload(
  selectedIds: Array<string | number>,
  executionParameters?: Record<string, unknown>,
): string {
  const payload: TaskPayload = {
    SelectedIds: selectedIds.map(String),
    ExecutionParameters: executionParameters ?? {},
  };

  return JSON.stringify(payload);
}
